export default __webpack_public_path__ + "i18n/translation-zh.0df12f6b.json";